import { ResponsiveLine } from "@nivo/line";

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const LineDiagram = ({ data /* see data tab */, legend = "cm/s" }: any) => {
  return (
    <ResponsiveLine
      data={data}
      margin={{ top: 5, right: 10, bottom: 50, left: 55 }}
      xScale={{ type: "point" }}
      yScale={{
        type: "linear",
        min: "auto",
        max: "auto",
        stacked: true,
        reverse: false,
      }}
      colors={{ scheme: "paired" }}
      yFormat=" >-.2f"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 90,
        legendOffset: 36,
        legendPosition: "middle",
      }}
      axisLeft={{
        tickSize: 5,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: -50,
        legend: legend,
        legendPosition: "middle",
      }}
      pointColor={{ theme: "background" }}
      pointBorderWidth={1}
      pointBorderColor={{ from: "serieColor", modifiers: [] }}
      pointLabelYOffset={-14}
      useMesh={true}
    />
  );
};

export default LineDiagram;
